<li class="activity {{key}} {{status}}"  {{#if disabled}}disabled="disabled"{{/if}}>
  <div class="activity-item">
    <a href="{{module}}/{{key}}" class="activity-link{{#if activity_link_class}} {{activity_link_class}}{{/if}}{{#if current}} active{{/if}}"
       aria-label="{{#if current}}{{#if title}}{{t title}}{{/if}} {{t 'currentPage'}}
       {{else}}{{#compare status '===' 'complete' }}{{#if title}}{{t title}}{{/if}}  {{t 'completed'}}{{/compare}}{{/if}}"></a>
    {{#if show_pages}}
      <ul class="activity-pages">
        {{#each pages}}
          <li class="activity-page {{status}} {{#if current}}active{{/if}}">
            <a href="#{{moduleKey}}/{{activityKey}}/{{key}}" {{#if disabled}}disabled="disabled" aria-disabled="true"{{/if}} {{#if current}}aria-label="{{#if title}}{{t title}}{{else}}{{key}}{{/if}} {{t 'selected'}}"{{/if}}>{{#if title}}{{t title}}{{else}}{{key}}{{/if}}</a>
          </li>
        {{/each}}
      </ul>
    {{/if}}
  </div>
</li>
